import { makeStyles } from '@material-ui/core/styles'

import colors from '@galo-monitor/styles/colors'

export default makeStyles({
  container: {
    padding: 0,
    position: 'relative'
  },
  listItemIcon: {
    minWidth: 35
  },
  emptyMessage: {
    textAlign: 'center'
  },
  item: {
    '& > *': {
      color: `${ colors.black  } !important`,
      '& span': {
        fontSize: '0.9rem !important'
      }
    }
  },
  loadingItems: {
    opacity: 0.8
  },
  loader: {
    position: 'absolute',
    marginTop: '0px !important'
  },
  actions: {
    top: '50%',
    right: 5,
    position: 'absolute',
    transform: 'translateY(-50%)'
  },
  actionItem: {
    '&:hover': {
      '& > *': {
        color: `${ colors.primary } !important`
      }
    }
  },
  registerBtnContainer: {
    position: 'absolute',
    right: 10,
    bottom: 10
  },
  registerBtn: {
    background: colors.primary
  }
})
